//import _ from 'lodash'

//import utility from '@/mixins/utility'

class Provider {

  #data = {}

  constructor(data={})
  {  
    this.#data = data
  }

  /**
   * Property getters.
   */
  
  get component()
  {
    return this.#data.component
  }

  get icon()
  {
    return this.#data.icon
  }

  get id()
  {
    return this.#data.id
  }

  get meta()
  {
    return this.#data.meta || {}
  }

  get name()
  {
    return this.#data.name
  }


  /**
   * Relationships.
   */
  

  /**
   * Computed properties.
   */
  
  
}

export default Provider